var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form", { attrs: { id: "editar-clave" } }, [
    _c(
      "div",
      { staticClass: "row justify-center" },
      [
        _c(
          "b-alert",
          {
            attrs: {
              dismissible: "",
              variant: "success",
              show: _vm.showSuccessAlert
            }
          },
          [
            _c("div", { staticClass: "alert-body" }, [
              _c("span", [
                _vm._v("Su clave ha sido actualizada correctamente!")
              ])
            ])
          ]
        )
      ],
      1
    ),
    _c("div", { staticClass: "vx-row mb-1" }, [
      _c(
        "div",
        { staticClass: "vx-col w-full" },
        [
          _c("vs-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required|min:4|max:20",
                expression: "'required|min:4|max:20'"
              }
            ],
            staticClass: "w-full",
            attrs: {
              autocomplete: "",
              "icon-pack": "material-icons",
              icon: "vpn_key",
              "icon-no-border": "",
              type: "password",
              "data-vv-as": "Clave actual",
              placeholder: "************",
              label: "Clave actual",
              name: "actualPassword",
              danger: _vm.errors.has("actualPassword"),
              "danger-text": _vm.errors.first("actualPassword")
            },
            on: {
              input: function($event) {
                return _vm.input("actualPassword", $event)
              }
            },
            model: {
              value: _vm.actualPassword,
              callback: function($$v) {
                _vm.actualPassword = $$v
              },
              expression: "actualPassword"
            }
          })
        ],
        1
      )
    ]),
    _c("div", { staticClass: "vx-row mb-1" }, [
      _c(
        "div",
        { staticClass: "vx-col w-full" },
        [
          _c("vs-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required|min:4|max:20",
                expression: "'required|min:4|max:20'"
              }
            ],
            ref: "newPassword",
            staticClass: "w-full",
            attrs: {
              autocomplete: "",
              "icon-pack": "material-icons",
              icon: "vpn_key",
              "icon-no-border": "",
              type: "password",
              "data-vv-as": "Clave nueva",
              label: "Clave nueva",
              placeholder: "************",
              name: "newPassword",
              danger: _vm.errors.has("newPassword"),
              "danger-text": _vm.errors.first("newPassword")
            },
            on: {
              input: function($event) {
                return _vm.input("newPassword", $event)
              }
            },
            model: {
              value: _vm.newPassword,
              callback: function($$v) {
                _vm.newPassword = $$v
              },
              expression: "newPassword"
            }
          })
        ],
        1
      )
    ]),
    _c("div", { staticClass: "vx-row mb-1" }, [
      _c(
        "div",
        { staticClass: "vx-col w-full" },
        [
          _c("vs-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required|confirmed:newPassword|min:4|max:20",
                expression: "'required|confirmed:newPassword|min:4|max:20'"
              }
            ],
            staticClass: "w-full",
            attrs: {
              autocomplete: "",
              "icon-pack": "material-icons",
              icon: "vpn_key",
              "icon-no-border": "",
              type: "password",
              "data-vv-as": "Repita clave nueva",
              label: "Repita clave nueva",
              placeholder: "************",
              name: "confirmationNewPassword",
              danger: _vm.errors.has("confirmationNewPassword"),
              "danger-text": _vm.errors.first("confirmationNewPassword")
            },
            on: {
              input: function($event) {
                return _vm.input("confirmationNewPassword", $event)
              }
            },
            model: {
              value: _vm.confirmationNewPassword,
              callback: function($$v) {
                _vm.confirmationNewPassword = $$v
              },
              expression: "confirmationNewPassword"
            }
          })
        ],
        1
      )
    ]),
    _c(
      "div",
      { staticClass: "vs-row" },
      [
        _c(
          "vs-col",
          {
            attrs: {
              "vs-offset": "2",
              "vs-type": "flex",
              "vs-justify": "center",
              "vs-align": "center",
              "vs-w": "8"
            }
          },
          [
            _c(
              "vx-tooltip",
              {
                attrs: {
                  text: "Al hacer click se modificara su clave",
                  position: "top"
                }
              },
              [
                _c(
                  "vs-button",
                  {
                    staticClass: "mt-5",
                    attrs: { disabled: !_vm.formValid(), type: "border" },
                    on: { click: _vm.modificarClave }
                  },
                  [_vm._v(" Cambiar ")]
                )
              ],
              1
            ),
            _c(
              "vs-button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showSuccessAlert && _vm.isUpdateBySystem,
                    expression: "showSuccessAlert && isUpdateBySystem"
                  }
                ],
                staticClass: "mt-5 ml-3",
                attrs: { color: "success" },
                on: {
                  click: function($event) {
                    return _vm.$router.push({ name: "iniciando" })
                  }
                }
              },
              [_vm._v(" Continuar ")]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }